import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    content: {
      marginTop: 32,
    },

    selectAll: {
      margin: '24px 0 16px',
    },
    checkboxCell: {
      padding: '0 8px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },

    buttons: {
      margin: '40px auto',
      paddingBottom: 24,

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },

    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },

    minimalTable: {
      '& .MuiTableRow-root': {
        height: 20,
      },

      '& .MuiTableCell-root': {
        padding: '0 8px',
      },
    },

    disableArea: {
      opacity: 0.5,
      pointerEvents: 'none',
    },

    pending: {
      background: 'rgba(239, 205, 51, .2)',
    },

    pendingList: {
      marginBottom: 16,

      '& .MuiAlert-root': {
        width: '100%',
        background: 'rgba(239, 205, 51, .2)',
      },

      '& .MuiAlert-message': {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: '8px',
      },

      '& .MuiAlertTitle-root': {
        width: '100%',
      },
    },

    notFountText: {
      marginBottom: 8,
    },
    deleteIcon: {
      width: 20,
      textAlign: 'center',
      '& .MuiIconButton-root': {
        padding: 0,
      },

      '& .MuiSvgIcon-root': {
        height: 17,
        width: 17,
      },
    },
    statusIcon: {
      width: 60,
      textAlign: 'center',
    },
    statusTitle: {
      justifyContent: 'center',
      fontSize: 12,
      color: palette.darkGrayColor,
    },
    centerStatus: {
      justifyContent: 'center',
      fontSize: 12,
    },
    container: {
      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    boxGrid: {
      borderRadius: 10,
      margin: '10px 0px',
      boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
      '&:last-child': {
        marginBottom: 30,
      },
      '& .MuiCardActions-root': {
        padding: 0,
      },
    },
    title: {
      alignItems: 'center',
      padding: '7px 10px !important',

      '& .PrivateSwitchBase-root': {
        padding: 0,
      },
      '& .MuiIconButton-root': {
        padding: 0,
        marginRight: 5,
        marginLeft: 7,
      },
    },
    superTitle: {
      alignItems: 'center',
      padding: '7px 15px !important',

      '& .PrivateSwitchBase-root': {
        padding: 0,
      },
      '& .MuiIconButton-root': {
        padding: 0,
        marginRight: 5,
        marginLeft: 7,
      },
    },
    titleText: {
      fontWeight: 500,
      fontSize: 14,
    },
    checkIcon: {
      color: `${palette.green} !important`,
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    root: {
      justifyContent: 'center',
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    table: {
      paddingBottom: 10,
    },
    switch: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',
      width: '15%',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },
    },
    switchModal: {
      paddingLeft: 15,
      alignItems: 'center',
      justifyContent: 'flex-start',
      display: 'flex',
      width: '100%',
      whiteSpace: 'nowrap',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },
    },
    listAll: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      margin: '0px 5px',
    },
    twoContainers: {
      padding: '0px 5px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    arrowIconUp: {
      transform: 'rotate(180deg)',
      transition: '0.6s ease',
    },
    arrowIconDown: {
      transform: 'rotate(0deg)',
      transition: '0.6s ease',
    },
    buttonExpand: {
      width: '100%',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    addButtonYellow: {
      alignItems: 'end',
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      alignItems: 'end',
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      alignItems: 'end',
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      alignItems: 'end',
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },

    header: {
      padding: '0 8px !important',
      fontSize: 12,
    },
    switchAll: {
      paddingBottom: 10,
      alignItems: 'center',
    },
    listGrid: {
      paddingLeft: 10,
    },
    contentTitle: { fontSize: 14, fontWeight: 500 },
    contentSubtitle: { fontSize: 12 },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    textField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    dateField: {
      color: palette.darkGray,
      fontSize: 12,
      whiteSpace: 'nowrap',
      textAlign: 'center',
    },
    alert: {
      maxWidth: 700,
      width: 'fit-content',
      margin: '0 auto',
      fontSize: 12,
    },
    warning: { marginTop: 20 },
    createOperator: { color: palette.blue, borderColor: palette.blue },
    accessButton: {
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: palette.blue,
      },
    },

    status: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: 'auto',
      cursor: 'default',

      '& .MuiTypography-root': {
        color: palette.deepBlue,
      },
    },
    template: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '8px',
      '& .MuiTypography-root': {
        fontSize: 14,
        fontWeight: 500,
      },
    },
    searchSize: { width: '87%' },
    listButtonSize: { margin: '0px 0px 0px 8px' },
    searchButtonSize: { margin: '0px 8px 0px 0px' },
    buttonsGrid: {
      justifyContent: 'space-between',
      display: 'flex',
      width: '13%',
    },
    buttonIsLoading: { backgroundColor: palette.borderGray },
  });
